import HttpClient from "./HttpClient";

class NewsletterClient extends HttpClient
{
    constructor()
    {
        super("/api/v1/newsletter/");
    }

    async SubscribeEmailAsync(email, context)
    {
       const body = { email, context };
       const captcha = await this.recaptchaToken();
       if (captcha) {
           body.captcha = captcha;
       }

       return await this.PostAsync("subscribe-email", null, body);
    }

    recaptchaToken()
    {
        const siteKey = window.APP_CAPTCHA_SITE_KEY;
        if (!siteKey || typeof grecaptcha === "undefined") {
            return Promise.resolve(null);
        }

        return new Promise((resolve) => {
            grecaptcha.ready(() => {
                grecaptcha.execute(siteKey, { action: "newsletter" }).then(resolve).catch(() => resolve(null));
            });
        });
    }

    async SubscribePhoneAsync(phone, context)
    {
        return await this.PostAsync("subscribe-phone", null, { phone, context });
    }
}

export default NewsletterClient;